import React, { useCallback, useState } from 'react';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';

import { media } from '../../../../utils/constants';
import { listStringToObject } from '../../../../utils/utils';
import SeeMoreText from '../../../SeeMoreText';
import MenuItem from '../../../MenuItem';
import MenuOptions from '../../../MenuOptions';

const useStyles = createUseStyles((theme) => ({
  activity: {},
  activityHeader: {
    composes: 'flexRow spaceBetween',
  },
  principalActivity: {
    flex: 2,
  },
  activityDescription: {},
  items: {
    padding: 0,
    margin: 0,
  },
  socialMedias: {},
  socialMediasItems: {
    composes: 'flexRow',
    margin: -theme.spacing(1),
  },
  socialMedia: {
    margin: theme.spacing(1),
    listStyle: 'none',
    '& a': {
      padding: 0,
    },
  },
  socialLogo: {
    width: 20,
  },
  block: {
    marginTop: theme.spacing(4),
  },
  contactItems: {
    composes: 'flexColumn',
    marginLeft: -theme.spacing(0.2),
    marginRight: -theme.spacing(0.2),
  },
  contactItem: {
    listStyle: 'none',
    [media.smDown]: {
      marginLeft: theme.spacing(0.2),
      marginRight: theme.spacing(0.2),
    },
  },
  seeMore: {
    fontWeight: 600,
    marginLeft: 12,
  },
  website: {
    marginTop: theme.spacing(1),
  },
}));

const PrincipalActivity = ({ result }) => {
  const classes = useStyles();

  const [open, setOpen] = useState({ email: false });

  const toggleEmail = () => setOpen(prev => ({ ...prev, email: !prev.email }));

  const getCieAbout = useCallback(() => {
    const langInfo = listStringToObject(result.cie_lang_info);
    const browserLanguages = navigator.languages;

    const defaultLangInfo = langInfo.find(l => browserLanguages.includes(l.cie_iso));
    let cie_about = defaultLangInfo?.cie_about;

    if (!defaultLangInfo) {
      const enLang = langInfo.find(l => l.cie_iso === 'en');
      cie_about = enLang?.cie_about;
    }

    return cie_about;
  }, [result]);

  const getCieEmail = useCallback((first) => {
    const emails = listStringToObject(result?.cie_mail);

    if (first) {
      return emails[0];
    }
    return emails;
  }, [result]);

  const cieEmailDefaultOption = getCieEmail(true)?.contact || getCieEmail(true)?.support || getCieEmail(true)?.rh || getCieEmail(true)?.sales 

  const socialLinks = (
    <ul className={clsx(classes.items, classes.socialMediasItems)}>
      {result?.cie_twitter && (
        <li className={classes.socialMedia}>
          <a href={result?.cie_twitter.raw}>
            <img alt="" src={process.env.PUBLIC_URL + '/images/social/twitter.svg'} className={classes.socialLogo} />
          </a>
        </li>
      )}
      {result?.cie_facebook && (
        <li className={classes.socialMedia}>
          <a href={result?.cie_facebook.raw}>
            <img alt="" src={process.env.PUBLIC_URL + '/images/social/facebook.svg'} className={classes.socialLogo} />
          </a>
        </li>
      )}
      {result?.cie_lk_url && (
        <li className={classes.socialMedia}>
          <a href={result?.cie_lk_url.raw}>
            <img alt="" src={process.env.PUBLIC_URL + '/images/social/linkedin.svg'} className={classes.socialLogo} />
          </a>
        </li>
      )}
    </ul>
  );

  return (
    <div className={classes.activity}>
      <div className={classes.activityHeader}>
        {result?.principal_activity && (
          <SeeMoreText 
            text={result?.principal_activity.raw}
            label="Principal Activity"
            action={socialLinks}
          />
        )}
      </div>
      {getCieAbout() && (
        <SeeMoreText 
          text={getCieAbout()} 
          label="About"
          className={classes.block}
        />
      )}
      <div className={classes.block}>
        <ul className={clsx(classes.items, classes.contactItems)}>
          <MenuItem label="Phone" text={result?.cie_phone} vertical />

          {/* ------------- email ------------- */}
          <MenuOptions
            open={open.email}
            onOpen={toggleEmail}
            defaultOption={cieEmailDefaultOption}
            label="Email"
            value={result?.cie_mail}
          >
            {getCieEmail().map((email, index) => (
              <MenuItem
                label={Object.keys(email) + ' : '} 
                text={result?.cie_mail}
                customValue={Object.values(email)}
                key={index} 
              />
            ))}
          </MenuOptions>
         <MenuItem
          label="Website"
          text={result?.cie_website}
          vertical
          className={classes.website}
        />
        </ul>
      </div>
    </div>
  );
}

export default PrincipalActivity;